import * as _ from 'underscore';

export class UrlBuilder {

  build(url, params) {
    let query = '';
    if (params) {
      _.each(params, (value, key) => {
        if (value) {
          const encodedKey = encodeURIComponent(key.toString());
          const encodedValue = encodeURIComponent(value.toString());
          query = `${query}&${encodedKey}=${encodedValue}`
        }
      });
      query = query.slice(1);
    }
    return (query !== '') ? `${url}?${query}` : url;
  }
}



// WEBPACK FOOTER //
// ./app/services/url/url.builder.ts